import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LoginPage.css";
import { loginUser } from "../api/auth";

const TouchLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      setError("ایمیل و رمز عبور را وارد کنید.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const tokens = await loginUser({ email, password });
      localStorage.setItem("access_token", tokens.access);
      localStorage.setItem("refresh_token", tokens.refresh);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "خطا در ورود. لطفا دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = () => {
    navigate("/forgot-password");
  };

  const handleRegister = () => {
    navigate("/register");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="touch-wrapper" dir="rtl">
      {error && (
        <div className="touch-toast">
          <div>
            <div className="touch-toast-title">خطا در ورود</div>
            <p className="touch-toast-body">{error}</p>
          </div>
        </div>
      )}
      <div className="touch-left">
        <div className="touch-logo-wrapper">
          <img
            src="/images/touch-prop-logo.png"
            alt="Touch Prop Logo"
            className="touch-logo"
          />
        </div>

        <div className="touch-left-content">
          <h1 className="touch-title">ورود به حساب تاچ پراپ</h1>
          <p className="touch-subtitle">
            ایمیل و رمز عبور خود را وارد کنید و مسیر معامله‌گری را ادامه بدهید.
          </p>

          <div className="touch-input-card">
            <input
              type="email"
              className="touch-input"
              placeholder="ایمیل"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <div className="touch-input-divider" />
            <div className="touch-input-icon">
              <span className="touch-input-icon-text">@</span>
            </div>
          </div>

          <div className="touch-input-card touch-password-card">
            <input
              type={showPassword ? "text" : "password"}
              className="touch-input"
              placeholder="رمز عبور"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <div className="touch-input-divider" />
            <div className="touch-input-icon">
              <button
                type="button"
                className="touch-eye-btn"
                onClick={() => setShowPassword((p) => !p)}
                aria-label="نمایش رمز"
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3.1 12.5C4.6 8.6 8 6 12 6c4 0 7.4 2.6 8.9 6.5a.9.9 0 0 1 0 .7C19.4 17.4 16 20 12 20c-4 0-7.4-2.6-8.9-6.5a.9.9 0 0 1 0-.7Z"
                      stroke="#444"
                      strokeWidth="1.5"
                    />
                    <circle cx="12" cy="13" r="3" stroke="#444" strokeWidth="1.5" />
                    <path d="M5 5l14 14" stroke="#444" strokeWidth="1.5" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3.1 12.5C4.6 8.6 8 6 12 6c4 0 7.4 2.6 8.9 6.5a.9.9 0 0 1 0 .7C19.4 17.4 16 20 12 20c-4 0-7.4-2.6-8.9-6.5a.9.9 0 0 1 0-.7Z"
                      stroke="#444"
                      strokeWidth="1.5"
                    />
                    <circle cx="12" cy="13" r="3" stroke="#444" strokeWidth="1.5" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="touch-register-row">
            <span>حساب نداری؟</span>
            <button
              type="button"
              className="touch-register-link"
              onClick={handleRegister}
            >
              ساخت حساب در تاچ پراپ
            </button>
          </div>

          <div className="touch-forgot-row">
            <span>رمز عبور را فراموش کرده‌ای؟</span>
            <button
              type="button"
              className="touch-forgot-link"
              onClick={handleForgot}
            >
              بازیابی رمز عبور
            </button>
          </div>

          <button
            type="button"
            className="touch-primary-btn"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "در حال ورود..." : "ورود"}
          </button>
        </div>
      </div>

      <div className="touch-right">
        <img
          src="/images/fingerprint-pattern.png"
          alt="Fingerprint"
          className="touch-fingerprint"
        />
        <div className="touch-right-overlay">
          <div className="touch-hero-text">
            <h2 className="touch-hero-title">تاچ پراپ ، لمس ثروت بی کران</h2>
            <p className="touch-hero-body">
              مسیر معامله‌گری هوشمند از همین‌جا شروع می‌شه
            </p>
            <div className="touch-dots">
              <span className="touch-dot touch-dot-active" />
              <span className="touch-dot" />
              <span className="touch-dot" />
              <span className="touch-dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TouchLogin;
